import SalesSlider from './SalesSlider'

export default SalesSlider
